import { komshipAxiosIns, newAxiosIns } from '@/libs/axios'

export function apiGetProuctList({ keyword, page, limit }) {
  const params = {
    keyword,
    page,
    limit,
  }
  return newAxiosIns.get('komship/api/v1/komchat/product', { params })
}
export function apiGetProuctLists({ keyword, page, limit }) {
  const params = {
    keyword,
    page,
    limit,
  }
  return newAxiosIns.get('/api/v1/product', { params })
}

export function apiGetProductListV4({ keyword, offset, limit }) {
  const params = {
    status: 1,
    limits: limit,
    offset,
  }
  if (keyword) {
    params.name = keyword
  }
  return komshipAxiosIns.get('/v4/product', { params })
}
